import React from 'react';
import ReactDOM from 'react-dom';
import { COM_PROPERTIES_KEY, HOME_PATH } from './constant/Constant';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { SnackbarProvider } from 'notistack';
import { BrowserRouter } from 'react-router-dom';
import rootReducer, { rootSaga } from './module';
import App from './App';
import { CookiesProvider } from 'react-cookie';
import reportWebVitals from './reportWebVitals';
import SessionStorageUtil from './util/SessionStorageUtil';
import { composeWithDevTools } from 'redux-devtools-extension';
import axios from 'axios';
import { MuiThemeProvider } from '@material-ui/core';
import './style/scss/index.scss';
import { theme } from './style/MuiTheme';

const sagaMiddleware = createSagaMiddleware();
const store = createStore(rootReducer, composeWithDevTools(applyMiddleware(sagaMiddleware)));
sagaMiddleware.run(rootSaga);

const initApp = new Promise(async (resolve, reject) => {
    try {
        {
            const { data } = await axios.request({ method: 'get', url: '/config.json', timeout: 10000 });
            console.log('CONFIG: ', data);
            SessionStorageUtil.setConfig(data);
        }
        {
            const { data } = await axios.request({ method: 'get', url: '/api/code/all', timeout: 10000 });
            // console.log('CODES: ', JSON.stringify(data));
            SessionStorageUtil.setCode(data);
        }
        {
            const { data } = await axios.request({
                method: 'get',
                url: `/api/com-prop/keys/${COM_PROPERTIES_KEY.CURRENT_SEMESTER}`,
                timeout: 10000,
            });
            console.log('CURRENT_SEMESTER: ', data);
            SessionStorageUtil.setCurrentSemester(data);
        }
        {
            const { data } = await axios.request({
                method: 'get',
                url: '/auth/recaptcha',
                timeout: 10000,
            });
            console.log('CAPTCHA: ', data);
            SessionStorageUtil.setCaptcha(data);
        }
        resolve();
    } catch (error) {
        console.error('name: ' + error.name + ', message: ' + error.message);
        reject();
    }
});

initApp
    .then(() =>
        ReactDOM.render(
            <Provider store={store}>
                <MuiThemeProvider theme={theme}>
                    <CookiesProvider>
                        <SnackbarProvider>
                            <BrowserRouter>
                                <App />
                            </BrowserRouter>
                        </SnackbarProvider>
                    </CookiesProvider>
                </MuiThemeProvider>
            </Provider>,
            document.getElementById('root'),
        ),
    )
    .catch((error) => {
        console.error('name: ' + error.name + ', message: ' + error.message);
        alert('시스템 작업 중 입니다. 잠시 후에 다시 시도해주세요.');
        window.history.pushState({}, '', HOME_PATH);
        window.location.reload();
    });

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
